// Painel lateral de variáveis do template (§4.5): chips com
// name + example vindos do contrato (variables[] do GET versions).
// Clique insere {{:name}} na posição do cursor do editor.
import { useTranslation } from "react-i18next"

import { Badge } from "@/components/ui/badge"
import type { NotificationTemplateVariableType } from "@/types/notification-center"

const editorPrefix =
  "pages.notificationCenter.templateEditorPage"

type TemplateVariablesPanelProps = {
  variables: NotificationTemplateVariableType[]
  onInsert: (name: string) => void
}

export const TemplateVariablesPanel = ({
  variables,
  onInsert,
}: TemplateVariablesPanelProps) => {
  const { t } = useTranslation()

  return (
    <aside
      className="space-y-2"
      aria-label={t(`${editorPrefix}.variables.title`)}
    >
      <h3 className="text-sm font-semibold">
        {t(`${editorPrefix}.variables.title`)}
      </h3>
      {variables.length === 0 ? (
        <p className="text-xs text-muted-foreground">
          {t(`${editorPrefix}.variables.empty`)}
        </p>
      ) : (
        <ul className="flex flex-wrap gap-2">
          {variables.map((variable) => (
            <li key={variable.name}>
              <button
                type="button"
                onClick={() => onInsert(variable.name)}
                title={variable.path}
                aria-label={t(
                  `${editorPrefix}.variables.insert`,
                  { name: variable.name }
                )}
                className="group"
              >
                <Badge
                  variant="outline"
                  className="rounded-full border font-normal transition-colors group-hover:bg-accent"
                >
                  <span className="font-medium">
                    {variable.name}
                  </span>
                  <span className="ml-1 max-w-32 truncate text-muted-foreground">
                    {variable.example}
                  </span>
                </Badge>
              </button>
            </li>
          ))}
        </ul>
      )}
    </aside>
  )
}
